import { StoreApi } from 'zustand';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { StoreSubscribeWithSelector } from './zustandTypes';

export type CreateBoundUseStore<S> = {
  (): ExtractState<S>;
  <T>(selector: (state: ExtractState<S>) => T, equals?: (a: T, b: T) => boolean): T;
};

export const createUseStore = <S extends StoreApi<unknown> & StoreSubscribeWithSelector<unknown>>(
  store: S
): CreateBoundUseStore<S> => {
  const useBoundStore: CreateBoundUseStore<S> = ((
    selector?: unknown,
    equals?: (a: unknown, b: unknown) => boolean
  ) => {
    if (!selector) {
      return useStoreWithEqualityFn(store as never, (state) => state, equals as never);
    }

    return useStoreWithEqualityFn(store as never, selector as never, equals as never);
  }) as CreateBoundUseStore<S>;

  return useBoundStore;
};

type ExtractState<S> = S extends { getState: () => infer X } ? X : never;
